<template>
  <div class="resourceList">
    <!-- 左边树状菜单 start-->
    <div class="resource-tree">
      <groupSelect
        ref="resourceTree"
        v-model:treeData.sync="treeData"
        v-model:currentNode.sync="currentNode"
        v-model:groupTypeCode.sync="groupTypeCode"
        :isDelete="isGroupDelete"
        :isRename="true"
        :isAdd="true"
        @Refresh="getTreeData"
        class="group-select"
      ></groupSelect>
    </div>
    <!-- 左边树状菜单 end-->
    <!-- 右边内容 start-->
    <div class="resource-content">
      <!-- 标题及搜索上传按钮 start-->
      <div class="resource-content_title">
        <span>{{ currentNode.Name }}</span>
        <span class="resource-content_title_selected">
          已选:
          <el-popover trigger="click">
            <el-table
              max-height="500px"
              border
              :data="currentItem"
              style="overflow-y: auto"
            >
              <el-table-column>
                <template #default="scope">
                  <img
                    title="点击放大"
                    v-viewer.rebuild="{ navbar: false }"
                    style="height: 30px; width: 50px"
                    :src="scope.row.ImgSrcNew"
                  />
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                property="FileName"
                label="名称"
                width="180"
              ></el-table-column>
              <el-table-column>
                <template #default="scope">
                  <el-button
                    type="text"
                    @click="currentItemRemove(scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <template v-slot:reference>
              <em>{{ currentItem.length }}</em>
            </template>
          </el-popover>
        </span>
        <div class="resource-content_title_opt">
          <el-input placeholder="请输入内容" v-model="keyWord" size="mini" style="margin: 0 10px;">
          </el-input><el-button  type="primary" size="mini"
              @click="getresourceList"
            >查询</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="updateImage(0)"
          >上传</el-button>
          <!-- <input size="mini" v-if="groupTypeCode != 1" type="file" @change="selectFile($event)" ref="file" /> -->
          <!-- <el-button  v-if="groupTypeCode != 1"
            type="primary"
            size="mini"
            @click="uploadMaterial()"
          >上传</el-button>
          <input type="file" style="display:none" ref="file" @click="e => {e.target.value = '';} " @change="selectFile($event)"/> -->

          <el-button  v-if="itemParam.source != 'ResourceCenter'"
            type="primary"
            size="mini"
            @click="confirm()"
          >确定</el-button>
        </div>
        <div class="resource-content_opt">
            <el-checkbox v-model="picAll"
              @change="onCheckbox">全选</el-checkbox>
            <em @click="onPicOper('upGroup')" >修改分组</em>
            <em @click="onPicOper('deletePic')">批量删除</em>
        </div>
      </div>
      <!-- 标题及搜索上传按钮 end-->
      <!-- 批量按钮操作 start-->

      <!-- 批量按钮操作 end-->
      <!-- 图片列表 start-->
      <div class="resource-content_list">
        <div
          class="pic-item"
          v-for="(item, index) in resourceData"
          :class="item.isChecked ? 'selected' : ''"
          :key="index"
          @click="onChoiceImg(item,index)"
        >
          <i class="el-icon-check"></i>
          <div class="pic-info">
            <div class="pic-info_img">
            <img v-if="groupTypeCode ==1"
                :src="item.ImgSrcNew"
                @dblclick="showBigImg(index)"
                title="" />
              <video v-if="groupTypeCode ==2 && index==playindex" width="240" height="140" controls="controls">
                <source :src="item.ImgSrcNew"  />
              </video>
              <img class="pic-video_img" v-if="groupTypeCode ==2 && index!=playindex" src="@/assets/video.png" title="" />
              <img v-if="groupTypeCode ==3"
                :src="GetDataPic(item)"
                title="" />
              <img v-if="groupTypeCode ==4"
                class="img-icon"
                :src="item.ImgSrcNew"
                @dblclick="showBigImg(index)"
                title="" />
            </div>
            <div class="pic-name">{{ item.FileName }}</div>
          </div>
          <div class="pic-oper">
            <a @click="onPicOper('renamePIC', item)">改名</a>
            <a @click="onPicOper('copyUrl', item)">链接</a>
            <a @click="onPicOper('upGroup', item)">分组</a>
            <a @click="onPicOper('deletePic', item)">删除</a>
          </div>
        </div>
      </div>
      <!-- 图片列表 end-->
      <!-- 分页控件 start-->
      <div class="resource-content_pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageIndex"
            :page-size="PageQuery.pageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      <!-- 分页控件 end-->
    </div>
    <!-- 右边内容 end-->

    <!--修改分组-选择分组 strat-->
    <el-dialog
      title="选择分组"
      v-model="dialogGroup.show"
      width="30%"
      :before-close="() => (dialogGroup.show = false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <groupSelect
        ref="resourceTreeSelect"
        v-model:treeData.sync="treeData"
        v-model:currentNode.sync="dialogGroup.current"
      ></groupSelect>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="dialogGroup.show = false">取 消</el-button>
          <el-button
            type="primary"
            @click="onGroupSave"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--修改分组-选择分组 end-->

    <!--修改图片名称 strat-->
    <el-dialog
      title="重命名"
      v-model="dialogRename.show"
      width="30%"
      :before-close="() => (dialogRename.show = false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-input
        v-model="dialogRename.value"
        placeholder="请输入内容"
      ></el-input>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="dialogRename.show = false">取 消</el-button>
          <el-button
            type="primary"
            @click="onRenameSave"
          >确 定</el-button>
        </span></template>
    </el-dialog>
    <!--修改图片名称 end-->

    <!-- 图片上传 strat-->
    <el-dialog
      title="上传"
      width="400px"
      v-if="dialogUpdate"
      v-model="dialogUpdate"
      :before-close="closeUpLoad"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-upload
        ref="updateImage"
        drag
        action="#"
        multiple
        :limit="10"
        :auto-upload="false"
        :show-file-list="true"
        :file-list="fileList"
        :accept="acceptName"
        list-type="resource"
        :before-upload="beforeUpload"
        :on-change="changeUploadImg"
        :on-remove="handleRemove"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template v-slot:tip>
          <div class="el-upload__tip"  v-if="groupTypeCode == 1 || groupTypeCode == 4">只能上传jpg/png图片</div>
          <div class="el-upload__tip"  v-if="groupTypeCode == 2">只能上传mp4/wmv/ram视频</div>
          <div class="el-upload__tip"  v-if="groupTypeCode == 3">支持文件格式pdf,word,ppt文件大小不可超过10M</div>
        </template>
        <el-progress v-if="videoFlag" :text-inside="true" :stroke-width="26" :percentage="videoUploadPercent" :color="customColorMethod"></el-progress>
      </el-upload>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="closeUpLoad">取 消</el-button>
          <el-button
            type="primary"
            @click="updateImage"
          >确定上传</el-button>
        </span></template>
    </el-dialog>
    <!-- 图片上传 end-->
  </div>
</template>
<script>
import {
  GetDataResourceGroupList,
  ModifyResourceGroup,
  DeleteResourceGroup,
} from "@api/ApiResourceGroup";
import {
  GetDataResourceCenterList,
  ModifyResourceCenter,
  DeleteResourceCenter,
  AddResourceCenter,
  AddResourceCenters,
  RenameResourceCenter,
  UpdResources,
  DelResources
} from "@api/ApiResourceCenter";
import {
  post,
} from '@/util/request'
import {getUserInfo} from '@/util/authority'
import groupSelect from "./groupSelect.vue";
import elementResizeDetectorMaker from "element-resize-detector";
import { api as viewerApi } from "v-viewer";
import { ossUpload, ossPreview, ossAbortMultipartUpload, ossDelete } from "@/util/ossClient.js"
import XEClipboard from 'xe-clipboard'
export default {
  name: "resourceList",
  data() {
    return {
      keyWord: "",
      pickAll: false,
      currentItem: [],
      resourceData: [],
      resourceSyncData: [],
      treeData: [],
      currentNode: {},
      dialogGroup: {
        show: false,
        current: {},
      },
      dialogRename: {
        show: false,
        fileCode: "",
        value: "",
      },
      linkDialogVisible: false,
      dialogBatch: {
        show: false,
        file: null,
      },
      dialogUpdate: false,
      fileList: [],
      acceptName:".jpg,.png,.jpeg", //文件格式
      playindex: 0,
      videoFlag: false,//进度条
      videoUploadPercent: 0,//进度条进度占比
      checkpoint: null,//上传断点信息
      PageQuery: {
        pageIndex: 1,
        pageSize: 20,
      },
      total: 0,
      operateObj: {
        multiple: false, //是否多选
      },
      picAll: false,
    };
  },
  props: ["groupTypeCode", "isDialog","itemParam"],
  components: {
    groupSelect: groupSelect,
  },
  mounted() {
    var that = this;
    // that.listenPageSize();
    that.$nextTick(function () {});
  },
  created() {
    var that = this;
    that.$nextTick(function () {

    });
  },
  setup(pro, content) {
    // const VUE_APP_API_URL = process.env.VUE_APP_API_URL ;
    // return {
    //   VUE_APP_API_URL,
    // };
  },
  methods: {
    //确认的点击事件
    confirm(){
      // debugger
      this.resourceData.forEach(x=>{
        x.isChecked=false;
      })
      var arr=this.currentItem;
      this.itemParam.sourceItem=arr;
      this.itemParam.groupTypeCode=this.groupTypeCode
      this.$emit("handle-confirm",this.itemParam);
    },
    uploadMaterial() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    //查看大图
    showBigImg(index) {
      viewerApi({
        images: this.resourceData.map((el) => {
          return el.ImgSrcNew;
        }),
        options: {
          initialViewIndex: index,
        },
      });
    },
    GetDataPic(item)
    {
      let textArray = item.ImgSrc.split('.');
      let extension = textArray[textArray.length - 1];// 取后缀名
      if(extension == 'doc' || extension == 'docx') {
        return require(`../../assets/images/word.png`);
      } else if(extension == 'pdf') {
        return require(`../../assets/images/pdf.png`);
      } else if(extension == 'ppt' || extension == 'pptx') {
        return require(`../../assets/images/ppt.png`);
      } else {
        return "";
      }
      //word
      // if(item.FileName && item.FileName.toLowerCase().indexOf('doc')>=0)
      // {
      //   return "data:image/png;base64,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";
      // }else if(item.FileName && item.FileName.toLowerCase().indexOf('pdf')>=0)
      // {
      //   //pdf
      //   return "data:image/png;base64,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";
      // }else
      // {
      //   //其他图片格式未设置
      //   return "";
      // }
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.pageSize != pageSize) {
        this.PageQuery.pageIndex = 1; 
        this.PageQuery.pageSize = pageSize;
      } else {
        this.PageQuery.pageIndex = currentPage;
      }
      this.getresourceList();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.getresourceList();
    },
    //全选
    onCheckbox(val) {
      this.resourceData.forEach((el) => {
        if (val) {
          this.currentItemPush(el);
        } else {
          this.currentItemRemove(el);
        }
      });
    },
    //向选中项中添加项目
    currentItemPush(item) {
      let index = this.currentItem.findIndex((el) => {
        return el.PicLogicalCode == item.PicLogicalCode;
      });
      if (index < 0) {
        item.isChecked = true;
        this.currentItem.push(item);
      }
    },
    //删除选中项
    currentItemRemove(item) {
      let that = this;
      let index = that.currentItem.findIndex((el) => {
        return el.PicLogicalCode == item.PicLogicalCode;
      });
      if (index >= 0) {
        that.currentItem.splice(index, 1);
        let data = that.resourceData.find((el) => {
          return el.PicLogicalCode == item.PicLogicalCode;
        });
        if (data) {
          data.isChecked = false;
        }
      }
    },
    handleRemove(file, fileList) {

    },
    changeUploadImg(file)
    {
      let _name = file.name.split('.');
      var filetype=_name[1];
      var lx=[];
      switch(filetype.toLowerCase())
      {
        case "jpg":
        case "png":
        case "jpeg":
          lx=['1','4'];
          break;
        case "avi":
        case "mp4":
        case "rm":
        case "ram":
        case "wmv":
          lx=['2'];
          break;
        case "pdf":
        case "doc":
        case "docx":
        case "ppt":
        case "pptx":
          lx=['3'];
          break;
      }
      if(!lx.includes(this.groupTypeCode))
      {
        this.$refs.updateImage.handleRemove(file);
        this.$message.error('上传格式错误')
        return false;
      }
      if (file.size / 1024 / 1024 > 800)
      {
        this.$refs.updateImage.handleRemove(file);
        this.$message.error('文件大小不可以超过800M')
        return false;
      }
    },
    beforeUpload(file)
    {
      let _name = file.name.split('.');
      if(_name[1] === 'jpg'||_name[1] === 'png'){
          return file
      }else {
          this.$message.error('上传文件只能是 jpg/png 格式!')
          return false
      }
    },
    //上传视频和文档
    selectFile(event) {
      var that=this;
      let files = event.target.files;
      var formData = new FormData();
      formData.append("File", files[0]);
      let loading = that.GetLoading("上传中...");
          post("/api/app/file/uploadFile", formData,{})
          .then((datas) => {
            // debugger
            //处理成功后插入数据
            if(datas)
            {
              var typeId=that.currentNode.Type;
              //未选择默认为未分组
              IF(typeId==0)
                typeId=-1;
              let params = {
                name: File.fileName,
                creatorName: getUserInfo().CodeID,
                type: that.groupTypeCode,
                url:datas,
                groupId:typeId
              };
              AddResourceCenter(params).then(function () {
                loading.close();
                that.refresh();
                  that.$message.success("新增成功!");
                  //重置file，否则change时间只会触发一次
                  that.$refs.file.value = null;
                  that.refresh();
              }).catch((e) => {
                loading.close();
                that.refresh();
              });
            }
          })
          // .then((result) => {
          //   loading.close();
          //   that.refresh();
          // })
          .catch((e) => {
            loading.close();
            that.$refs.file.value = null;
          });
    },
    customColorMethod (percentage) {
      if (percentage < 30) {
        return '#909399'
      }
      if (percentage < 70) {
        return '#e6a23c'
      }
      return '#67c23a'
    },
    progress(p, _checkpoint) {
      // Object的上传进度。
      this.videoFlag = true
      this.videoUploadPercent = parseInt(p * 100);
      this.checkpoint = _checkpoint;
      if(p == 1) {
        this.checkpoint = null;
      }
      console.log(p);
      // 分片上传的断点信息。
      console.log(_checkpoint);
    },
    //关闭页面
    closeUpLoad(){
      if(this.videoFlag && this.videoUploadPercent < 1 && this.checkpoint != null) {
        this.$confirm("上传还未完成，确认取消？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          ossAbortMultipartUpload(this.checkpoint.name,this.checkpoint.uploadId);
          this.resetData();
        });
      } else {
        this.resetData();
      }
    },
    resetData(){
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      this.checkpoint = null;
      this.dialogUpdate = false;
    },
    multiUpload(fileName,File){
      return ossUpload(fileName, File,this.groupTypeCode,this.progress)
    },
    //上传图片
    updateImage(type) {
      // debugger
      let that = this;
      if (type == 0) {
        if (that.groupTypeCode == 1) {
          that.dialogUpdate = true;
        } else {
          that.dialogUpdate = true;
        }
      } else {
        let files = that.$refs.updateImage.uploadFiles;
        if (files.length <= 0) {
          that.$message.warning("请先选择图片文件!");
          return;
        }
        files = that.$refs.updateImage.uploadFiles.map((el) => {
          return el.raw;
        });
        let promiselist = [];
        let addlist = [];
        let typeId=that.currentNode.Type;
        if(typeId==0)
          typeId=-1;
        let loading = that.GetLoading("上传中...");
        let fileindex = 1;
        files.forEach(item => {
          let File=item;
          File.fileName=item.name;
          let textArray = File.fileName.split('.');
          let extension = '.' + textArray[textArray.length - 1];// 取后缀名
          let fileName = Date.parse(new Date()) + fileindex + extension;
          let params = {
            name: File.fileName,
            creatorName: getUserInfo().CodeID,
            type: that.groupTypeCode,
            url:fileName,//存Oss管理器上的文件名
            groupId:typeId
          };
          addlist.push(params);
          promiselist.push(that.multiUpload(fileName,File))
          fileindex++;
        })
        //批量上传
        Promise.all(promiselist).then((result) => {
          AddResourceCenters(addlist).then(function (result) {
            loading.close();
            that.$message.success("新增成功!");
            that.resetData();
            that.refresh();
          }).catch((e) => {
            that.$message.error(e);
            loading.close();
          });
        })
        .catch((e) => {
          loading.close();
        });
        /*
        var formData = new FormData();
         var File=files[0];
         File.fileName=files.map((el) => {return el.name;}).join("|");
        formData.append(
          "File", files[0]
        );
        let textArray = File.fileName.split('.');
        let extension = '.' + textArray[textArray.length - 1];// 取后缀名
        let fileName = Date.parse(new Date()) + extension;
        // let loading = that.GetLoading("上传中...");
        //上传到Oss
        ossUpload(fileName, File,that.groupTypeCode,that.progress).then((result) => {
          var typeId=that.currentNode.Type;
          let params = {
            name: File.fileName,
            creatorName: getUserInfo().CodeID,
            type: that.groupTypeCode,
            url:fileName,//存Oss管理器上的文件名
            groupId:typeId
          };
          AddResourceCenter(params).then(function () {
            that.$message.success("新增成功!");
            that.refresh();
          });
        })
        .then((result) => {
          // loading.close();
          that.resetData();
          that.refresh();
        })
        .catch((e) => {
          // loading.close();
        });
        */
        /*
          post("/api/app/file/uploadFile", formData,{})
          .then((datas) => {
            // debugger
            //处理成功后插入数据
            if(datas)
            {
              var typeId=that.currentNode.Type;
              let params = {
                name: File.fileName,
                creatorName: getUserInfo().CodeID,
                type: that.groupTypeCode,
                url:that.VUE_APP_API_URL+'/api/app/file/download?filename='+File.fileName,//datas,
                groupId:typeId
              };
              AddResourceCenter(params).then(function () {
                  that.$message.success("新增成功!");
                  that.refresh();
              });
            }
          })
          .then((result) => {
            loading.close();
            that.dialogUpdate = false;
            that.refresh();
          })
          .catch((e) => {
            loading.close();
          });
          */
      }
    },
    //全部删除
    deleteAll() {
      let that = this;
      this.$confirm("确定全部删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {});
    },
    //删除图片
    deletePic({ flowNo, fileCode, ossfileName }) {
      let that = this;
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        //处理删除图片
        debugger
        if(typeof fileCode == "string" && fileCode.indexOf(',')>0)
        {
          var _data=fileCode.split(",");
          var _datas=[];
          _data.forEach(d=>{
            var _t=
            {
                id: d,
                lastModifierName: getUserInfo().CodeID,
            };
            _datas.push(_t);
          });
          DelResources(_datas).then(function (result) {
            that.$message.success("删除成功!");
            that.refresh();
          });
        }else{
          DeleteResourceCenter(fileCode).then(function (result) {
            that.$message.success("删除成功!");
            that.refresh();
          });
        }
        // 从Oss上删除
        ossDelete(ossfileName, that.groupTypeCode);
      });
    },
    //重命名
    onRenameSave() {
      let that = this;
      if (!that.dialogRename.value) {
        that.$message.warning("名称不能为空!");
        return;
      }
      RenameResourceCenter(that.dialogRename.fileCode,that.dialogRename.value)
      .then(()=>{
        that.$message.success("修改成功!");
        that.dialogRename.show = false;
        that.dialogRename.fileCode = "";
        that.dialogRename.value = "";
        that.refresh();
      })
    },
    //修改分组
    onGroupSave() {
      let that = this;
      if(that.dialogGroup.type=='2')
      {
        var _data=that.dialogGroup.fileCode.split(",");
        var _datas=[];
        _data.forEach(d=>{
           var _t=
           {
              id: d,
              type: that.groupTypeCode,
              groupid:that.dialogGroup.current.Type,
              lastModifierName: getUserInfo().CodeID,
           };
           _datas.push(_t);
        });
        //批量修改
        UpdResources(_datas).then(function (result) {
          that.$message.success("修改成功!");
          that.dialogGroup.show = false;
          that.dialogGroup.current = {};
          that.dialogGroup.flowNo = "";
          that.dialogGroup.fileCode = "";
          that.dialogGroup.name="";
          that.dialogGroup.url="";
          that.refresh();
        });
      }else{
        let params = {
          id: that.dialogGroup.fileCode,
          type: that.groupTypeCode,
          groupid:that.dialogGroup.current.Type==0?-1:that.dialogGroup.current.Type,
          lastModifierName: getUserInfo().CodeID,
          name:that.dialogGroup.name,
          url:that.dialogGroup.url,
        };
        ModifyResourceCenter(params).then(function (result) {
          that.$message.success("修改成功!");
          that.dialogGroup.show = false;
          that.dialogGroup.current = {};
          that.dialogGroup.flowNo = "";
          that.dialogGroup.fileCode = "";
          that.dialogGroup.name="";
          that.dialogGroup.url="";
          that.refresh();
        });
      }
    },
    //修改图片分组
    upGroup({ flowNo, fileCode },item) {
      this.dialogGroup.show = true;
      this.dialogGroup.current = {};
      this.dialogGroup.fileCode = fileCode;
      if(item){
        this.dialogGroup.name=item.FileName;
        this.dialogGroup.url=item.ImgSrc;
        this.dialogGroup.type='1';
      }else
      {
        this.dialogGroup.type='2';
      }
    },
    //复制链接
    copyUrl({ fileUrl }) {
      if (XEClipboard.copy(fileUrl)) {
        this.$message({ type: 'success', message: '已复制到剪贴板！'})
      }
    },
    //重命名
    renamePIC({ fileCode, fileName }) {
      this.dialogRename.show = true;
      this.dialogRename.fileCode = fileCode;
      this.dialogRename.value = fileName;
    },
    //操作事件
    onPicOper(type, item) {
      item=eval(item);
      let that = this;
      let flowNo = "";
      let fileCode = "";
      let fileUrl = "";
      let fileName = "";
      let ossfileName = "";
      if (item) {
        flowNo = item.PicLogicalCode;
        fileCode = item.PicLogicalCode;
        fileUrl = item.ImgSrcNew;
        fileName = item.FileName;
        ossfileName = item.ImgSrc;
      } else {
        if (this.currentItem.length <= 0) {
          this.$message.warning("请先选择数据!");
          return;
        }
        flowNo = that.currentItem
          .map((el) => {
            return el.FlowNo;
          })
          .join(",");
        fileCode = that.currentItem
          .map((el) => {
            return el.PicLogicalCode;
          })
          .join(",");
        ossfileName = that.currentItem
          .map((el) => {
            return el.ImgSrc;
          });
      }
      that[type]({ flowNo, fileCode, fileUrl, fileName, ossfileName }, item);
    },
    //获取分组信息
    async getTreeData() {
      //debugger
      let that = this;
      var params={
        queryModel: {
          type:this.groupTypeCode,
          sortField: {
            CreationTime: "desc",
          },
        },
        pageindex: 1,
        PageSize: 1000,
      };
      let treeData = [];
      //获取分组数据
      await GetDataResourceGroupList(params).then(function (data) {
          //转为统一的格式
          var obj=data.entities;
          var picMenuList=[];
          var _picMenu1=
          {
            Type:"-1",
            Name:"未分组",
            GroupLevel:0,
            PicCounts:0,
            ParentType:'RootNode'
          };
          picMenuList.push(_picMenu1);
          if(obj && obj.length>0)
          {
            obj.forEach(row=>{
              var _picMenu=
              {
                Type:row.id,
                Name:row.name,
                PicCounts:0,  //数量
                GroupLevel:0,
                ParentType:'RootNode'
              };
              picMenuList.push(_picMenu);
            });
          }
          var _tree1=
          {
            Type:"0",
            Name:"全部",
            GroupLevel:-1,
            PicCounts:0,
            ParentType:'RootNode',
            MenuList:picMenuList
          };
          treeData.push(_tree1);
      });
      that.treeData = treeData;
      if (that.treeData.length > 0 && !that.currentNode.Name) {
        that.currentNode = that.treeData[0];
      }
    },
    //图片选择事件
    onChoiceImg(item,selectindex) {
      // debugger
      if(this.groupTypeCode == "2") {
        this.playindex = selectindex;
      }
      let that = this;

      let index = that.currentItem.findIndex((el) => {
        return el.PicLogicalCode == item.PicLogicalCode;
      });

      if(that.itemParam.isSingle){
        //单选
        if(!item.isChecked){
          that.currentItem=[];
          that.resourceData.forEach(x=>{
            x.isChecked=false;
          })

          item.isChecked=true;
          that.currentItemPush(item);
        }else{
          item.isChecked=false;
          that.currentItem.splice(index, 1);
        }

        return
      }

      if (index >= 0) {
        that.pickAll = false;
        item.isChecked = false;
        that.currentItem.splice(index, 1);
      } else {
        that.currentItemPush(item);
        //如果页面已经全选了则设置全选按钮选中状态
        var notIndex = that.resourceData.findIndex((el) => {
          return el.isChecked != true;
        });
        if (notIndex < 0) {
          that.pickAll = true;
        }
      }
    },
    //图片列表
    getresourceList() {
      let that = this;
      // debugger
      var groupid=that.currentNode.Type;
      if(groupid=='RootNode')
        groupid='0';
      var params={
        queryModel: {
          type:that.groupTypeCode,
          groupid:groupid,
          name:that.keyWord,
          sortField: {
            CreationTime: "desc",
          },
        },
        pageindex: this.PageQuery.pageIndex,
        PageSize: this.PageQuery.pageSize,
      };
      that.resourceData = [];
      //获取资源数据
      GetDataResourceCenterList(params).then(function (data) {
          //转为统一的格式
          var obj=data.entities;
          that.total =data.totalCount;
          var picList=[];
          if(obj && obj.length>0)
          {
            obj.forEach(row=>{
              var _pic=
              {
                PicLogicalCode:row.id,
                GroupCode:row.groupId,
                FileName:row.name,
                ImgSrc:row.url,
                ImgSrcNew:ossPreview(row.url,row.type),
              };
              picList.push(_pic);
            });
          }
          that.resourceData=picList;

          //如果存在 itemParam 且有选中的情况 则选中
          if(that.itemParam && that.itemParam.selectId!=0){
            that.currentItem=[]
            that.resourceData.forEach(x=>{
              x.isChecked = false
              if(that.itemParam.selectId==x.PicLogicalCode)
              {
                x.isChecked=true
                that.currentItemPush(x);
              }
            })
          }

      });
    },
    //权限处理
    checkQX(btn) {
      return true;
    },
    //刷新数据
    async refresh() {
      this.currentItem = [];
      await this.getTreeData();
      this.getresourceList();
    },
    setDesc(val)
    {
      // debugger
      if(val == 1 || val == 4)
       this.acceptName=".jpg,.png,.jpeg";
      else if(val == 2)
       this.acceptName=".avi,.mp4,.rm,.ram,.wmv";
      else if(val == 3)
       this.acceptName=".doc,.pdf,.docx,.ppt,.pptx";
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  computed: {
    //是否是商品目录
    isGoods() {
      return this.groupTypeCode == "1";
    },
    //是否显示树形删除按钮
    isGroupDelete() {
      return !this.isDialog && this.checkQX("SCFZ");
    },
    //是否显示树形重命名按钮
    isGroupRename() {
      return !this.isDialog && this.checkQX("CMM");
    },
    //是否显示新增按钮
    isGroupAdd() {
      return !this.isDialog && this.checkQX("XZFZ");
    },
  },
  watch: {
    //图片大类变化监控
    groupTypeCode: {
      handler(val) {
        this.getTreeData();
        this.setDesc(val);
      },
      immediate: true,
    },
    //分组变化监控
    currentNode() {
      this.getresourceList();
    },
  },
};
</script>
<style scoped>
.group-select{
  height: 100%;
}
.resourceList .resource-tree {
  border: 1px solid #c9cace;
  width: 190px;
  padding: 10px 10px 0;
  position: relative;
  height: 99%;
  display: inline-block;
  box-sizing: border-box;
  overflow-y: scroll; 
}
.resourceList .resource-content {
  position: relative;
  min-height: 580px;
  height: 100%;
  float: right;
  width: calc(100% - 230px);
  overflow: scroll; 
  left: 0;
  bottom: 60px;
  padding: 60px 0 0;
  box-sizing: border-box;
}
.resourceList .resource-content_title{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.resourceList .resource-content_title > span:first-child {
  text-overflow: ellipsis;
  word-break: keep-all;
  overflow: hidden;
  color: black;
  font-size: 16px;
}
.resourceList .resource-content_title .resource-content_title_selected {
  margin-left: 15px;
  color: #bbbbbb;
}
.resourceList .resource-content_title .resource-content_title_selected em {
  color: #4291ed;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
}
.resourceList .resource-content_title_opt {
  text-align: right;
  float: right;
  margin-right: 20px;
  flex: 1;
}
.resourceList .resource-content_title_opt >>> .el-input {
  width: 215px;
}
.resourceList .resource-content_opt {
  height: 40px;
  line-height: 40px;
  width: 100%;
  background-color: #f0f4f9;
  padding-left: 20px;
  margin-top: 10px;
}
.resourceList .resource-content_opt em {
  color: #999999;
  cursor: pointer;
  margin-left: 15px;
  font-size: 14px;
}
.pictureList .resource-content_opt em:hover {
  text-decoration: underline;
}

.resourceList .resource-content_list {
  margin-top: 20px;
}
.resourceList .resource-content_list .pic-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;
  line-height: 19px;
  width: 140px;
  box-sizing: border-box;
  font-size: 14px;
  position: absolute;
  bottom: 10px
}
.resourceList .resource-content_list .pic-name:hover{
  overflow:visible;
  white-space: pre-line;
  background: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 5px;
  margin: 0;
}
.resourceList .resource-content_list .pic-item {
  float: left;
  margin-left: 11px;
}
.resourceList .resource-content_list .pic-info {
  position: relative;
  padding: 10px;
  border: 1px solid transparent;
  cursor: pointer;
}
.resourceList .resource-content_list .pic-info:hover,
.resourceList .resource-content_list .selected .pic-info {
  background-color: #eff6ff;
  border: 1px solid #bbd3ef;
}
.resourceList .resource-content_list .pic-info .pic-info_img {
  position: relative;
  padding-bottom: 15px;
}
.resourceList .resource-content_list .pic-info .pic-info_img > div {
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}
.resourceList .resource-content_list .pic-info .pic-info_img > div > i {
  display: block;
  border-bottom: 1px solid #dcdcdc;
  margin-left: 3px;
}
.resourceList .resource-content_list .pic-info .pic-info_img > img {
  width: 140px;
  height: 140px;
}
.resourceList .resource-content_list .pic-info .pic-info_img > img:is(.img-icon) {
  width: 20px;
  height: 20px;
}
.resourceList .resource-content_list .pic-item .pic-oper {
  text-align: center;
  padding-bottom: 5px;
}
.resourceList .resource-content_list .pic-item .pic-oper > a {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  color: #4291ed;
  margin: 2px;
  text-decoration: none;
  cursor: pointer;
}
.resourceList .resource-content_list .pic-item > .el-icon-check {
  display: none;
}
/* .resourceList .resource-content_list .pic-item:hover > .el-icon-check, */
.resourceList .resource-content_list .selected > .el-icon-check {
  position: absolute;
  display: block !important;
  font-size: 20px;
  z-index: 1;
  width: 0;
  color: #ffffff;
  height: 0;
  border-top: 40px solid #3680d5;
  font-weight: bolder;
  border-right: 40px solid transparent;
}
.resourceList .resource-content_list .pic-item > .el-icon-check::before {
  position: absolute;
  top: -35px;
  left: 4px;
}
.resourceList .resource-content_pagination {
  position: fixed;
  bottom: 25px;
  right: 15px;
}
.resource-tree :deep(.el-tree) {
  position: absolute;
  bottom: 34px;
  overflow-y: auto;
  top: 42px;
  width: 100%;
}
.resourceList .resource-content_list .pic-info .pic-video_img {
  width: 240px !important;
  height: 140px !important;
}
</style>
